import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import { ROUTES } from '../../config/routes.config';
import { isQrAdmitted, qrCaseViewPath, qrScanPath } from '../../utils/qrSession';
import CaseQRViewPage from './CaseQRViewPage';

/**
 * Protects the mobile case view: requires login AND a fresh QR scan admission flag.
 * Legacy QRs pointing at /qr/cases/:id are sent back through /qr/scan/:id to force login.
 */
const CaseQRViewGate: React.FC = () => {
  const { caseId } = useParams<{ caseId: string }>();
  const { isAuthenticated } = useAuthStore();
  const navigate = useNavigate();

  useEffect(() => {
    if (!caseId) {
      navigate(ROUTES.LOGIN, { replace: true });
      return;
    }
    if (!isAuthenticated) {
      navigate(ROUTES.LOGIN, {
        replace: true,
        state: { from: qrCaseViewPath(caseId) },
      });
      return;
    }
    if (!isQrAdmitted(caseId)) {
      navigate(qrScanPath(caseId), { replace: true });
    }
  }, [caseId, isAuthenticated, navigate]);

  if (!caseId || !isAuthenticated || !isQrAdmitted(caseId)) {
    return null;
  }

  return <CaseQRViewPage />;
};

export default CaseQRViewGate;
